var _path, _path2, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.86548 31.6462C9.86548 26.48 14.0535 22.292 19.2197 22.292H37.7795C42.9457 22.292 47.1337 26.48 47.1337 31.6462C47.1337 36.8123 42.9457 41.0004 37.7795 41.0004H19.2197C14.0535 41.0004 9.86548 36.8123 9.86548 31.6462ZM39.3331 31.5959C39.3331 33.6665 37.6546 35.345 35.584 35.345C33.5135 35.345 31.8349 33.6665 31.8349 31.5959C31.8349 29.5253 33.5135 27.8468 35.584 27.8468C37.6546 27.8468 39.3331 29.5253 39.3331 31.5959ZM21.4134 35.345C23.4839 35.345 25.1625 33.6665 25.1625 31.5959C25.1625 29.5253 23.4839 27.8468 21.4134 27.8468C19.3428 27.8468 17.6643 29.5253 17.6643 31.5959C17.6643 33.6665 19.3428 35.345 21.4134 35.345Z",
    fill: "#337FF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.55 20V20C37.55 17.2386 35.3115 15 32.55 15H28.55M19.55 20V20C19.55 17.2386 21.7886 15 24.55 15H28.55M28.55 15V20",
    stroke: "#337FF5",
    strokeWidth: 2.85795
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.5632,
    y: 27.7603,
    width: 21.8748,
    height: 7.6967,
    rx: 3.84835,
    fill: "#343434"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.8501,
    y: 28.9756,
    width: 2.02545,
    height: 5.06362,
    rx: 1.01272,
    fill: "#337FF5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 46.1128,
    y: 28.9756,
    width: 2.02545,
    height: 5.06362,
    rx: 1.01272,
    fill: "#337FF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f03cee69d510d7a7a6f2e436c70129b9.svg";
export { ForwardRef as ReactComponent };